import { FieldValues, UseControllerProps } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CounterInputControl } from 'components/_basic/Form/TextInput';
import { ITextFieldProps } from 'components/_basic/Form/TextInput/TextInput/types';

import { daysRegex } from './constants';

export const DaysInputControl = <T extends FieldValues>(props: UseControllerProps<T> & ITextFieldProps) => {
  const { t } = useTranslation();
  return (
    <CounterInputControl
      type="text"
      {...props}
      regex={daysRegex}
      postfix={t('days')}
      shift={30}
      maxValue={90}
      minValue={30}
    />
  );
};
